import React, { useState } from 'react'

const Footerdetail = (props) => {
  return (
    <>
      <div id='footerdetail'>
        <div id='callus'>
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <h3>Do you need the RO Maintenance Services?</h3>
                <br />
                <a className="btn-right" href="#contact">Book A Free Assessment</a>

              </div>

              <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12 contact-info">
                <div className='contact-item'>
                  <h3>Contact Info</h3>
                  {/*
                                <p>
                                    <span>
                                        <i className='fa fa-map-marker'></i> Address:
                                    </span>
                                    {props.data ? props.data.address : 'loading'}
                                </p>
                              */}
                </div>
                <div className='contact-item'>
                  <p>
                    <span>
                      <i className='fa fa-phone'></i> Phone:
                    </span>{' '}
                    <a href="tel: 9031062011">
                      {props.data ? props.data.phone : 'loading'}</a>
                  </p>
                </div>
                <div className='contact-item'>
                  <p>
                    <span>
                      <i className='fa fa-envelope-o'></i> Email:
                    </span>{' '}
                    <a href="mailto: aquapureroservices@gmail.com">
                      {props.data ? props.data.email : 'loading'}</a>
                  </p>
                </div>
                <div className='contact-item'>
                  <p>
                    <span>
                      <i className='fa fa-whatsapp'></i> Whatsapp:
                    </span>{' '}
                    <a href="https://api.whatsapp.com/send?phone=919031062011" target="_blank">
                      {props.data ? props.data.phone : 'loading'}</a>
                  </p>
                </div>
                {/*
                <div className='contact-item'>
                  <p>
                    <span>
                      <i className='fa fa-map-marker'></i> {props.data ? props.data.address : 'loading'}
                    </span>{' '}
                  </p>
                </div>
                  */}

              </div>


              <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12">
                <h3>UseFul Links</h3>
                <div className="row">
                  <div className="col-xs-6 col-md-6">
                    <ul className='contact-item'>
                      <li>
                        <a href='#contact' className='page-scroll'>
                          Contact
                        </a>
                      </li>
                      <li>
                        <a href='#features' className='page-scroll'>
                          What We Do
                        </a>
                      </li>
                      <li>
                        <a href='#about' className='page-scroll'>
                          About
                        </a>
                      </li>
                      <li>
                        <a href='#pricetag' className='page-scroll'>
                          Pricing
                        </a>
                      </li>
                      <li>
                        <a href='#services' className='page-scroll'>
                          Services
                        </a>
                      </li>
                      <li>
                        <a href='#testimonials' className='page-scroll'>
                          Testimonials
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="col-xs-6 col-md-6">

                    <ul className='contact-item'>
                      <li>
                        <a href='/return-policy'>
                          Return Policies
                        </a>
                      </li>
                      <li>
                        <a href='/privacy-policy' >
                          Privicy Policies
                        </a>
                      </li>
                      <li>
                        <a href='/terms-condition'>
                          Terms & Condition
                        </a>
                      </li>
                      <li>
                        <a href='/faq'>
                          FAQs
                        </a>
                      </li>
                      <li>
                        <a href='/help-center'>
                          Help Center
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </>
  )
}

export default Footerdetail;